import { render, staticRenderFns } from "./ColumnMappingDropdown.vue?vue&type=template&id=ddb187dc&scoped=true&lang=html&"
import script from "./ColumnMappingDropdown.vue?vue&type=script&lang=js&"
export * from "./ColumnMappingDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb187dc",
  null
  
)

export default component.exports